module.exports = __webpack_public_path__ + "img/empty-profile-male.8d4b933a.svg";